import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Col, Row } from 'react-bootstrap';
import { ArrowForward, Favorite, FavoriteBorder, } from '@mui/icons-material';
import { logo } from '../config/Config';
import blog_card from "../Assets/images/blog_card.jpg"



const Blog = () => {
    const [isIconClicked, setIsIconClicked] = useState(false);

    const handleIconClick = () => {
      // Toggle the clicked state
      setIsIconClicked(!isIconClicked);
    };

 


    const [isExpanded, setIsExpanded] = useState(false);

    const toggleContent = () => {
        setIsExpanded(!isExpanded);
    };


    const BlogData = [
        {
            "imgageLink": blog_card,
            // "imgageLink": "http://localhost:3000/static/media/category.014c3fd27ad2ce74ad28.jpg",
            "heading": "Plan Your Project With Your Software",
            "description": "Planning a software project is a crucial step to ensure its success. Below is a comprehensive guide that covers various aspects of planning a software project. Keep in mind that the specific details may vary based on the type of project, size of the team, and other factors.",
            "shortcont": "Planning a software project is a crucial step to ensure its success. Below is a comprehensive guide that covers various aspects of planning a software project...",
            "learnmore": "Learn More",
            "showless": "Show Less",
        },



    ]


    const BlogList = [
        {
            "name": "DESIGN",
            "value": 3,
            "link": "/web-design",
        },

        {
            "name": "DEVELOPEMNT",
            "value": 3,
            "link": "/webdeveloper",
        },

        {
            "name": "SEO",
            "value": 3,
            "link": "/search-engine",
        },

        {
            "name": "MOBILE APPS",
            "value": 3,
            "link": "/mobile-app",
        },

    ]


    return (
        <>
            <div className="blog">
                <div className="banner_section">
                    <div className="container-layout">
                        <div className="blog_heading">
                            <h1>Blog</h1>
                            <ul className="breadcrumb">
                                <li><a href="/">Home</a></li>
                                <li>Blog</li>
                            </ul>


                        </div>
                    </div>
                </div>

                <div className="category">
                    <div className="container-layout">
                        <Row className="category_row">
                            <Col xl={9} lg={8} className="padding_set">
                                {BlogData?.map((item: any, index: any) => {
                                    return (
                                        <>
                                            <div className="category_left" key={index}>

                                                <div className="image_section">
                                                    <img src={item?.imgageLink} alt="category_pic" />

                                                    <div className="plan">
                                                        <div className="link_section">
                                                            <p>_ November 21, 2019</p>
                                                            <p>_ Tom Black_ </p>
                                                            <p>0 Comments</p>

                                                        </div>
                                                        <h6 className="plan_project">{item?.heading}</h6>

                                                        <p>{isExpanded ? item?.description : item?.shortcont}</p>
                                                        <div className="learn_more">
                                                            <button className="learn" onClick={toggleContent}>
                                                                <ArrowForward className="arrow_icon" /> {isExpanded ? item?.showless : item?.learnmore}
                                                            </button>

                                                            {/* <div className="numeric">
                                                                {isFavorite ? (
                                                                    <Favorite className="heart_icon" onClick={handleIconClick} />
                                                                ) : (
                                                                    <FavoriteBorder className="heart_icon" onClick={handleIconClick} />
                                                                )}

                                                                1.01K
                                                            </div> */}

                                                            <div className="numeric" onClick={handleIconClick}>
                                                                {isIconClicked ? (
                                                                    <Favorite className="heart_icon" />
                                                                ) : (
                                                                    <FavoriteBorder className="heart_icon" />
                                                                )}
                                                                1.01K
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </>
                                    )
                                })}

                            </Col>
                            <Col xl={3} lg={4} className="padding_set for_changing_box" >
                                <div className="category_right">
                                    <div className="category_list">
                                        <h3>Category</h3>

                                        {BlogList?.map((item: any, index: any) => {
                                            return (
                                                <>
                                                    <div className="design_sec" key={index}>
                                                        <Link to={item?.link}>{item?.name} <span>({item?.value})</span></Link>
                                                    </div>
                                                </>
                                            )

                                        })}
                                    </div>
                                    <div className="right_image">
                                        <div className="inner_content">
                                            <div className="data">
                                                <img src={logo} alt='logo' />
                                                <h6>Let's Build<br />
                                                    Your Website</h6>
                                                <div className="contact">
                                                    <a href='/contact'>Contact</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                            </Col>
                        </Row>
                    </div>
                </div>
                {/* 
                <div className="pagination">
                    <div className="container-layout">
                        <div className="pagination_section">
                            <Link to="/">1</Link>
                            <Link to="/">2</Link>
                            <Link to="/">3</Link>
                            <Link to="/"><ArrowForward className="arrow_icon" /></Link>
                        </div>
                    </div>
                </div> */}

            </div>
        </>
    );
}

export default Blog;

